<!-- 主播房间入口 -->
<template>
  <li
    :class="[
      'ShowRoomEntrance-Component',
      'showbiz-room-item',
      {
        'response-room-item': responsive,
        'only-show-first-row': onlyShowFirstRow
      }
    ]"
  >
    <nuxt-link
      :to="
        localePath(linkTo ? linkTo : `/${roomInfo.bigoID || roomInfo.bigo_id}`)
      "
      :title="roomInfo.room_topic || roomInfo.nick_name"
    >
      <div
        v-lazy-container="{
          selector: 'img',
          error: defaultCover,
          loading: defaultCover
        }"
        class="showbiz-room-item__cover"
      >
        <img
          :data-src="roomInfo.cover_l || roomInfo.data5"
          :alt="roomInfo.room_topic || 'bigo'"
        />

        <div v-if="roomInfo.user_count >= 1000" class="hot-icon"></div>
      </div>

      <div class="hover-bg-box">
        <span class="hover-bg"></span>
      </div>

      <div class="showbiz-room-item__detail-box">
        <div
          class="room-avatar"
          :style="{
            backgroundImage: `url(${roomInfo.data5 ||
              'https://static-web.likeevideo.com/as/bigo-static/www.bigo.tv/img/logo_icon.png'})`
          }"
        ></div>
        <p class="room-name">{{ roomInfo.room_topic }}</p>
        <div
          :class="['name-box', { 'name-box-max-width': !roomInfo.room_topic }]"
        >
          {{ roomInfo.nick_name }}
        </div>
        <span class="viewer-num">
          {{ roomInfo.user_count }}
        </span>
      </div>
    </nuxt-link>
  </li>
</template>

<script>
export default {
  props: {
    linkTo: {
      type: String,
      default: ''
    },
    roomInfo: {
      type: Object,
      default: () => ({})
    },
    // 是否随窗口大小改变尺寸
    responsive: {
      type: Boolean,
      default: false
    },
    // 是否只显示第一行
    onlyShowFirstRow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    this.defaultCover =
      'data:image/jpeg;base64,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';
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import '~assets/scss/mixin.scss';

.showbiz-room-item {
  display: block;
  float: left;
  height: 0;
  padding-bottom: 310px;
  position: relative;

  a {
    display: block;
    margin-right: 20px;
  }

  .showbiz-room-item__cover {
    height: 214px;
    width: 250px;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }

    .hot-icon {
      position: absolute;
      right: 8px;
      top: 8px;
      width: 46px;
      height: 19px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      background-image: url('~@assets/img/hot.png');
    }
  }

  .showbiz-room-item__detail-box {
    position: relative;
    top: -15px;
    z-index: 9;
    overflow: hidden;
    width: 250px;
    height: 87px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url('~@assets/img/video-bg2.png');
    padding: 4px 12px;

    .room-avatar {
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      border-radius: 50%;
    }

    .room-name {
      @include els();

      font-size: 16px;
      font-weight: 500;
      color: #2f3033;
      line-height: 19px;
      margin-top: 7px;
      max-width: 180px;
    }

    .name-box {
      @include els();

      font-size: 14px;
      font-weight: 400;
      color: #8a8f99;
      line-height: 16px;
      margin-top: 3px;

      &.name-box-max-width {
        max-width: 180px;
      }
    }

    .viewer-num {
      position: absolute;
      right: 12px;
      bottom: 34px;
      display: block;
      font-size: 14px;
      font-weight: 400;
      color: #8a8f99;
      line-height: 16px;

      &::before {
        content: '';
        float: left;
        position: relative;
        top: 1px;
        width: 14px;
        height: 14px;
        margin-right: 3px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        background-image: url('~@assets/img/people.png');
      }
    }
  }

  &:hover .hover-bg-box,
  &:hover .hover-bg {
    z-index: 9;
    opacity: 1;
    filter: alpha(opacity=100);
    transform: scale(1);
  }

  &.response-room-item {
    a {
      margin-right: 23px;
    }
  }
}

.hover-bg-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 20px;
  bottom: 95px;
  z-index: -1;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  filter: alpha(opacity=0);
  transition: all 0.2s;
  overflow: hidden;
  border-radius: 3px;

  .hover-bg {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 54px;
    height: 54px;
    z-index: -1;
    margin-top: -27px;
    margin-left: -27px;
    opacity: 0;
    background: url(~@assets/img/video_h.png) center no-repeat;
    transform: scale(2);
    transition: all ease-out 250ms;
    filter: alpha(opacity=0);
  }
}

// .only-show-first-row {
//   display: none;
// }

// @media (min-width: 1601px) {
//   .response-room-item {
//     width: 16.666%;
//     padding-bottom: 16.666%;

//     &.only-show-first-row:nth-child(1),
//     &.only-show-first-row:nth-child(2),
//     &.only-show-first-row:nth-child(3),
//     &.only-show-first-row:nth-child(4),
//     &.only-show-first-row:nth-child(5),
//     &.only-show-first-row:nth-child(6) {
//       display: block;
//     }

//     // .showbiz-room-item__cover {
//     //   width: auto;
//     //   height: auto;
//     // }
//   }
// }

// @media (min-width: 1301px) and (max-width: 1600px) {
//   .response-room-item {
//     width: 20%;
//     padding-bottom: 20%;

//     &.only-show-first-row:nth-child(1),
//     &.only-show-first-row:nth-child(2),
//     &.only-show-first-row:nth-child(3),
//     &.only-show-first-row:nth-child(4),
//     &.only-show-first-row:nth-child(5) {
//       display: block;
//     }

//     // .showbiz-room-item__cover {
//     //   width: auto;
//     //   height: auto;
//     // }
//   }
// }
// @media (max-width: 1300px) {
//   .response-room-item {
//     width: 25%;
//     padding-bottom: 25%;

//     &.only-show-first-row:nth-child(1),
//     &.only-show-first-row:nth-child(2),
//     &.only-show-first-row:nth-child(3),
//     &.only-show-first-row:nth-child(4) {
//       display: block;
//     }

//     // .showbiz-room-item__cover {
//     //   width: auto;
//     //   height: auto;
//     // }
//   }
// }
</style>
